export const getDateWithoutTimeZone = () => {
  const date = new Date()
  const userTimezoneOffset = date.getTimezoneOffset() * 60000
  const dateWithouTimeZone = new Date(date.getTime() - userTimezoneOffset)
  dateWithouTimeZone.setHours(0, 0, 0, 0)
  return dateWithouTimeZone
}